const configService = {
  apiURL: ''
}

export default configService
